import {createActions} from '../../framework';

const normalActions = [
  'SET_ALLOW_NULL',
  'SET_START_DATE',
  'SET_END_DATE',
  'SET_MAX_RANGE',
  'VALIDATE_FORM',
  'RESET_STORE'
];

export default createActions(null, normalActions);
